<!-- banner section start-->
<div class="object-cover md:hidden">
  <img
    class="mx-auto"
    src="assets/images/beautybook/mobile-bb-banner.png"
    alt="" />
  <img
    class="mx-auto"
    src="assets/images/beautybook/mobile-bb-howto.png"
    alt="" />
</div>
<div class="my-10 hidden object-cover md:block">
  <img class="mx-auto" src="assets/images/beautybook/bb-banner.png" alt="" />
  <img
    class="mx-auto h-80"
    src="assets/images/beautybook/bb-howto.png"
    alt="" />
</div>
<!-- banner and how to section end -->

<!-- beautybook  start -->
<div class="mx-auto my-10">
  <div class="my-10 mx-auto max-w-md text-center">
    <div
      class="bg-gradient-to-r from-primary-darkest to-primary-md-dark bg-clip-text font-playfair-display text-5xl leading-tight text-transparent text-primary-darkest">
      BEAUTY <br />
      BOOK
    </div>
  </div>
  <!-- beautybook items -->
  <div class="container mx-auto px-5 py-9 md:px-14 lg:px-20 xl:px-48">
    <div class="mt-6">
      <!-- <div
        class="grid grid-cols-1 gap-x-9 gap-y-6 px-10 md:grid-cols-2 md:px-0 lg:grid-cols-4 xl:grid-cols-5"> -->
      <div class="flex flex-wrap content-center justify-center gap-x-9 gap-y-6">
        <ng-container *ngIf="beautybookPosts.length">
          <div *ngFor="let post of beautybookPosts" class="flex flex-col">
            <fc-beautybook-item [post]="post"></fc-beautybook-item>
          </div>
        </ng-container>
      </div>
      <!-- </div> -->
    </div>
  </div>
  <!-- skeleton start -->
  <div
    *ngIf="loading"
    class="hot-deals container mx-auto px-5 py-9 md:px-14 lg:px-20 xl:px-48">
    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
      <div class="product-wishlist-loading" *ngFor="let item of [1, 2, 3, 4]">
        <p-skeleton class="w-full" height="19rem"></p-skeleton>
      </div>
    </div>
  </div>
  <!-- skeleton end -->
  <!-- beautybook items end -->
</div>
<!-- beautybook  end -->
